import { push as redirectTo } from 'connected-react-router';
import React from 'react';
import { useDispatch, connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Strong, Text } from '@summer/ui-components/src';

import { TextContainer } from 'components/pages/default/wizard/layout/layout';
import { OTPPage } from 'components/pages/userIdentityVerification/OtpPage';
import {
  verifyAccountRecoveryEmailOtp,
  sendUserAccountRecoveryOTPNotification,
} from 'redux/actions/accountRecovery.actions';
import { clearServerError } from 'redux/actions/ui.actions';
import {
  verifyAccountRecoveryEmailOtpLabel,
  sendAccountRecoveryEmailOtpNotificationLabel,
} from 'redux/middleware/accountRecovery.middleware';
import { getErrorCode } from 'redux/selectors/ui.selectors';
import { addWbrToLongEmail } from 'utils/email';

const errorMessages = new Map([
  [429, 'Too many requests. Please wait for 1 minute before trying again.'],
  [500, 'Something went wrong. Please try again.'],
]);

const AccountRecoveryEmailOtp = ({ verifyErrorCode, sendErrorCode }) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const { recovery } = location.state || { recovery: {} };
  const email = recovery?.obfuscatedEmail;
  const phone = recovery?.obfuscatedPhone;
  if (!email || !phone) {
    dispatch(redirectTo('/login'));
  }
  const title = 'Verify your email address to continue';

  const errorMessage = verifyErrorCode
    ? errorMessages.get(verifyErrorCode) ||
      'Something went wrong. Please try again.'
    : null;

  const handleSubmitUserOTPVerificationCode = code => {
    dispatch(verifyAccountRecoveryEmailOtp({ code }, { recovery }));
    dispatch(clearServerError(verifyAccountRecoveryEmailOtpLabel));
  };

  const handleSendUserOtpNotification = () => {
    dispatch(sendUserAccountRecoveryOTPNotification());
    dispatch(clearServerError(sendAccountRecoveryEmailOtpNotificationLabel));
  };

  return (
    <>
      <OTPPage
        pageTitle={title}
        email={email}
        onSubmitCode={handleSubmitUserOTPVerificationCode}
        onSendCode={handleSendUserOtpNotification}
        sendOTPNotificationErrorCode={sendErrorCode}
        error={errorMessage}
        submitCodeErrorCode={verifyErrorCode}
        subTitleComponent={
          <TextContainer>
            <Text large center paragraph>
              Enter code sent to <Strong>{addWbrToLongEmail(email)}</Strong>
            </Text>
          </TextContainer>
        }
      />
    </>
  );
};

const mapStateToProps = state => ({
  verifyErrorCode: getErrorCode(state, verifyAccountRecoveryEmailOtpLabel),
  sendErrorCode: getErrorCode(
    state,
    sendAccountRecoveryEmailOtpNotificationLabel,
  ),
});

export default connect(mapStateToProps)(AccountRecoveryEmailOtp);
